import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../../../../services/common';
import { FormGroup } from '@angular/forms';
import { SalesService } from '../../../sales.service';
import { environment } from '../../../../../../environments/environment';
import { IconList } from '../../../../../../iconlist';
import { coApplicantColDefs, familyColDefs, IFormInfo, nomineeColDefs, otherChargesColDefs, paymentSchedule, summaryTreeNodes } from '../allotment-addupdate.model';
import { TreeNode } from 'primeng/api';
import { AddressType, AmountSubTypes, UserSubType } from '../../../../../../appconfig';
import { DatePipe } from '@angular/common';
import { FormIdentity } from '../../../../../common-components/common-form/common-form.model';

@Component({
  selector: 'app-receipt-details',
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.scss'
})
export class PaymentDetailsComponent implements OnInit {

  @Input() allotmentRelatedData: any;
  @Input() formGroup!: FormGroup;

  firmDetails = false;
  showAdressModal: boolean = false;
  adressMetaData: any;
  addressToAndFromAddressDetail: any;
  showDetailedModal: boolean = false;
  coApplicantDetailsConfig: any;
  formIdentity!: FormIdentity;
  formDataConfig: any = null;
  nomineeColumnDefs: any[] = [];
  familyColumnDefs: any[] = [];
  coApplicantColumnDefs: any[] = [];
  coAppRowData: any;
  familyRowdata: any;
  nomineeRowData: any;
  nomineeDetails = false;

  familyDetails = false;
  emergencyDetails = false;
  constructor(
    public commonService: CommonService,
    private salesService: SalesService,
    private cdr: ChangeDetectorRef
  ) {


  }

  ngOnInit(): void {

  }

  nomineeDetailsConfig: any[] = [
    { name: 'firstName', label: 'First Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'lastName', label: 'Last Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'contact', label: 'Contact Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'email', label: 'Email', type: 'email', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'dob', label: 'Date of Birth', type: 'date', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'relation', label: 'Relation', type: 'dropdown', options: ['Father', 'Mother', 'Sibling'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'gender', label: 'Gender', type: 'dropdown', options: ['Male', 'Female', 'Other'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidType', label: 'UID Type', type: 'dropdown', options: ['Aadhaar', 'Passport', 'Voter ID'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidNumber', label: 'UID Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'bloodGroup', label: 'Blood Group', type: 'dropdown', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], validations: { required: true, minLength: 10, maxLength: 50 } }
  ]

  familyMemberDetailsConfig: any[] = [
    { name: 'nameInitails', label: 'Name Initial', type: 'dropdown', options: ['Mr.', 'Mrs.', 'Miss.', 'Dr.', 'Sh.', 'Smt.'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'firstName', label: 'First Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'lastName', label: 'Last Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'contact', label: 'Contact Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'email', label: 'Email', type: 'email', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'dob', label: 'Date of Birth', type: 'date', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'relation', label: 'Relation', type: 'dropdown', options: ['Father', 'Mother', 'Sibling'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'gender', label: 'Gender', type: 'dropdown', options: ['Male', 'Female', 'Other'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidType', label: 'UID Type', type: 'dropdown', options: ['Aadhaar', 'Passport', 'Voter ID'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidNumber', label: 'UID Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'bloodGroup', label: 'Blood Group', type: 'dropdown', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], validations: { required: true, minLength: 10, maxLength: 50 } }
  ];
  togglefirmDetails() {

  }

  closeAddAddressModal(event: any) {
    this.showAdressModal = false;
  }

  addfirmAddressModal(addressType: any): void {
    //  let address: any = {};
    this.setAddressMetaData(addressType);
    if (addressType == AddressType.Firm) {
      this.adressMetaData.addressLabel = 'Firm';
    }
    // this.adressMetaData.addressType = address.addressType  ?? address.assressType;
    // this.adressMetaData.address = address;
    this.showAdressModal = true;


  }


  setAddressMetaData(addressType: any) {
    this.adressMetaData = {
      "addressLabel": '',
      "subTypeId": UserSubType.Client,
      "addressType": addressType,
      "address": {
        "address1": '',
        "cityId": '',
        "village": '',
        "stateId": '',
        "Pincode": ''
      },
      "fullAdress": ''
    }
  }

  additionalDetails(formType: string) {
    this.formDataConfig = undefined;
    this.showDetailedModal = false;
    //@ts-ignore
    this.formIdentity = FormIdentity[formType];
    switch (this.formIdentity) {
      case FormIdentity.coApplicantDetails:
        this.formDataConfig = this.coApplicantDetailsConfig;
        break;
      case FormIdentity.familyMemberDetails:
        this.formDataConfig = this.familyMemberDetailsConfig;
        break;
      case FormIdentity.nomineeMemberDetails:
        this.formDataConfig = this.nomineeDetailsConfig;
        break;
    }
    this.showDetailedModal = true;

    this.cdr.markForCheck();
    // setTimeout(() => {
    // })
  }

  onCommonFormSubmit(formInfo: IFormInfo) {
    if (formInfo) {
      switch (formInfo.formIdentity) {
        case FormIdentity.coApplicantDetails:
          this.coApplicantColumnDefs = coApplicantColDefs;
          if (Array.isArray(formInfo.formData)) {
            this.coAppRowData = formInfo.formData;
          } else {
            let arr: any = [];
            const obj: any = {};
            Object.keys(formInfo.formData).forEach((key, index) => {
              obj[key] = formInfo.formData[key];
            });
            arr.push(obj);

            this.coAppRowData = arr;
          }
          break;
        case FormIdentity.familyMemberDetails:
          this.familyColumnDefs = familyColDefs;
          if (Array.isArray(formInfo.formData)) {
            this.familyRowdata = formInfo.formData;
          } else {
            let arr: any = [];
            const obj: any = {};
            Object.keys(formInfo.formData).forEach((key, index) => {
              obj[key] = formInfo.formData[key];
            });
            arr.push(obj);

            this.familyRowdata = arr;
          }
          // choose col definition
          // use forminfo.formData
          break;

        case FormIdentity.nomineeMemberDetails:
          this.nomineeColumnDefs = nomineeColDefs;
          if (Array.isArray(formInfo.formData)) {
            this.nomineeRowData = formInfo.formData;
          } else {
            let arr: any = [];
            const obj: any = {};
            Object.keys(formInfo.formData).forEach((key, index) => {
              obj[key] = formInfo.formData[key];
            });
            arr.push(obj);

            this.nomineeRowData = arr;
          }

          break;
      }
    }
    this.showDetailedModal = false;

  }


  hideCommonFormModal() {
    this.showDetailedModal = false;
  }
  toggleNomineeDetails() {
    this.nomineeDetails = !this.nomineeDetails
  }
  toggleEmergencyDetails() {
    this.emergencyDetails = !this.emergencyDetails
  }

  togglefamilyDetails() {
    this.familyDetails = !this.familyDetails
  }

}
